import { defineElement, html, TemplateElement } from '@webtides/element-js';
import CalendarElementEvent from './CalendarElementEvent';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import style from './event-calendar.css';

class EventCalendarElement extends TemplateElement {
    styles() {
        return [style];
    }

    properties() {
        return {
            calendarEvent: [],
            locale: 'de',
            modalElement: false,
            past: false,
            isTeaser: false,
        };
    }

    events() {
        return {
            '[ref="moreInfo"]': {
                click: () => {
                    this.dispatch(CalendarElementEvent.CLICK, this.calendarEvent.id, true);
                },
            },
            '[ref="addToCalendar"]': {
                click: () => {
                    window.open(
                        this.site +
                            '.ics?eventId=' +
                            this.calendarEvent.id +
                            '&deepLink=' +
                            this.calendarEvent.eventLink.href,
                    );
                },
            },
        };
    }

    cssShadow() {
        if (this.isTeaser) {
            return 'shadow';
        }
        if (!this.modalElement) {
            return 'shadow md:shadow-none';
        }
    }

    template() {
        return html`
            <div class="event-item ${this.cssShadow()} my-3 flex flex-row flex-wrap md:flex-nowrap">
                <div
                    class="${this.modalElement
                        ? 'h-full'
                        : ''} order-1 flex-1 bg-brand-100 px-8 pb-2 pt-1 text-brand-500">
                    <div class="${this.isTeaser ? 'text-3xl' : 'text-6xl'}">${this.calendarEvent.date}</div>
                    <div class="flex border-b-2 border-brand-200 text-lg">
                        ${this.calendarEvent.month} ${this.calendarEvent.year}
                    </div>
                    <div class="flex items-center whitespace-nowrap">
                        <svg-use name="icons-material-outline-clock" class="mr-1 h-4 w-4"></svg-use>
                        <div>
                            <span class="lowercase">${this.calendarEvent.localTime}</span>
                            ${this.locale === 'de' ? 'Uhr' : ''} (${this.calendarEvent.timeZone})
                        </div>
                    </div>
                    ${this.calendarEvent.location
                        ? html`
                              <div class="flex items-center">
                                  <svg-use name="icons-material-outline-location" class="mr-1 h-4 w-4"></svg-use>
                                  <div class="w-28 truncate">${this.calendarEvent.location}</div>
                              </div>
                          `
                        : ''}
                </div>
                <div
                    class="${this.modalElement ? '' : 'event-description'} ${this.isTeaser
                        ? 'bg-white'
                        : 'bg-grey-50'} order-3 flex w-full flex-row justify-between p-3 pl-8 md:order-2">
                    <div class="flex flex-col">
                        ${this.modalElement === true || this.isTeaser
                            ? ''
                            : html`
                                  <div class="flex items-center font-medium text-grey-400">
                                      ${this.calendarEvent.category}
                                      <svg-use name="icons-material-outline-keyboard-arrow-right" class="mx-1 h-5 w-5">
                                          <svg>
                                              <use
                                                  xlink:href="/.resources/aurubis-light-module/webresources/icons/symbol/svg/sprite.symbol.svg#icons-material-outline-keyboard-arrow-right"></use>
                                          </svg>
                                      </svg-use>
                                      ${this.calendarEvent.subCategory}
                                  </div>
                              `}
                        <div class="mb-2 text-xl font-bold text-black">${this.calendarEvent.title}</div>
                        ${this.modalElement === true
                            ? ''
                            : html`
                                  <div
                                      ref="moreInfo"
                                      class="mt-3 flex cursor-pointer items-center font-medium text-brand-500">
                                      ${this.moreInformation}
                                      <svg-use name="icons-material-outline-keyboard-arrow-right" class="mx-1 h-5 w-5">
                                          <svg>
                                              <use
                                                  xlink:href="/.resources/aurubis-light-module/webresources/icons/symbol/svg/sprite.symbol.svg#icons-material-outline-keyboard-arrow-right"></use>
                                          </svg>
                                      </svg-use>
                                  </div>
                              `}
                        ${this.modalElement === false
                            ? ''
                            : html`
                                  <div class="mb-10">${unsafeHTML(this.calendarEvent.description)}</div>

                                  ${Object.keys(this.calendarEvent).length > 0 &&
                                  this.calendarEvent.attachments.map((item) => {
                                      if (item['type'] === 'asset') {
                                          return html`
                                              <a
                                                  href="${item['href']}"
                                                  class="list mb-8 font-medium text-brand-500 hover:text-brand-700"
                                                  download>
                                                  ${item['label']}
                                              </a>
                                          `;
                                      }
                                      return html`
                                          <a
                                              href="${item['href']}"
                                              target="${item['target']}"
                                              class="list mb-8 font-medium text-brand-500 hover:text-brand-700">
                                              ${item['label']}
                                          </a>
                                      `;
                                  })}
                                  ${this.calendarEvent.modalLink && this.calendarEvent.modalLink.href
                                      ? html`
                                            <div class="flex">
                                                <a
                                                    class="btn-secondary px-14 py-2 font-medium"
                                                    href="${this.calendarEvent.modalLink.href}"
                                                    target="${this.calendarEvent.modalLink.target}">
                                                    ${this.calendarEvent.modalLink.label}
                                                </a>
                                            </div>
                                        `
                                      : ''}
                              `}
                    </div>
                </div>
                <div
                    class="${this.modalElement ? '' : 'event-icons'} ${this.isTeaser
                        ? 'bg-white'
                        : 'bg-grey-50'} order-2 flex flex-col p-2 text-brand-500 md:order-3">
                    ${this.past === true
                        ? ''
                        : html`
                              <div
                                  ref="addToCalendar"
                                  class="cursor-pointer hover:text-brand-700"
                                  title="${this.calendarHoverText}">
                                  <svg-use name="icons-material-outline-calendar-add" class="h-8 w-8"></svg-use>
                              </div>
                          `}
                    <share-element
                        edit-mode="${this.editMode}"
                        titel="${this.titel}"
                        text="${this.text}"
                        copy-text="${this.copyText}"
                        copy-button="${this.copyButton}"
                        share-url="${this.calendarEvent.eventLink?.href ?? ''}"
                        modal-id="${this.calendarEvent.id}"
                        icon-size="big"
                        hover-title="${this.shareHoverText}"></share-element>
                </div>
            </div>
        `;
    }
}

export function define() {
    defineElement('event-calendar-element', EventCalendarElement);
}
